import FlexPane from './_flex-pane.js'
import EventCardSkeleton from './_event-card-skeleton.js'

export default {
  name: 'EventCardsSkeleton',
  values: {
    numberOfCards: 3,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          overflow: 'hidden',
        },
      },
    },
    eventCardSkeleton: {
      configSet: EventCardSkeleton,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
